import { cva, VariantProps } from 'class-variance-authority';

export const root = cva(['flex'], {
  variants: {
    direction: {
      vertical: ['flex-col'],
      horizontal: [
        'flex-row',
        'items-center',
        '[&>li:not(:last-child)]:pb-0',
        '[&>li:not(:first-child)]:pt-0',
        '[&>li:not(:last-child)]:pr-3',
        '[&>li]:after:h-0',
        '[&>li]:after:w-2',
        '[&>li]:after:right-[0.35rem]',
        '[&>li]:after:left-auto',
        '[&>li]:after:bottom-1/2',
        '[&>li]:after:translate-y-1/2',
      ],
    },
  },
  defaultVariants: {
    direction: 'vertical',
  },
});

export type RootStyleProps = VariantProps<typeof root>;

export const item = cva(
  [
    'relative',
    'flex',
    'flex-row',
    'items-center',
    'gap-2',
    '[&:not(:first-child)]:pt-1',
    '[&:not(:last-child)]:pb-3',
    'after:content-[""]',
    'last:after:content-[none]',
    'after:h-2',
    'after:border',
    'after:absolute',
    'after:left-[0.9375rem]',
    'after:bottom-0',
  ],
  {
    variants: {
      active: {
        true: ['after:border-primary-800'],
        false: ['after:border-neutral-400'],
      },
    },
  }
);

export type ItemStyleProps = VariantProps<typeof item>;
